'use client';

import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from '~/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer relative inline-flex size-3.5 shrink-0 items-center justify-center rounded-[3.5px] border border-foreground/25 bg-background transition-[background-color,border-color,box-shadow,transform] duration-150',
      'hover:border-foreground/40',
      'focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:ring-offset-1 focus-visible:ring-offset-background',
      'data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
      'data-[state=checked]:hover:border-primary data-[state=checked]:hover:bg-primary',
      'active:scale-[0.96]',
      'disabled:cursor-not-allowed disabled:opacity-100',
      'disabled:border-foreground/10 disabled:bg-muted disabled:hover:border-foreground/10',
      'disabled:data-[state=checked]:border-transparent disabled:data-[state=checked]:bg-foreground/25 disabled:data-[state=checked]:text-background',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
      <Check className="size-2.5" strokeWidth={3} absoluteStrokeWidth />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
